import { getRequest, type IValidatedResponse } from '../../httpClient';
import type { IGetMovieRatingV1Request } from './get-movie-rating-v1-request';
import {
  getMovieRatingV1ResponseSchema,
  type IGetMovieRatingV1Response,
} from './get-movie-rating-v1-response';

export async function getMovieRatingV1Api({
  collectionId,
}: IGetMovieRatingV1Request): Promise<IValidatedResponse<IGetMovieRatingV1Response>> {
  return getRequest<IGetMovieRatingV1Response>({
    path: `/user-collections/${collectionId}/rating/v1`,
    schema: getMovieRatingV1ResponseSchema,
  });
}
